import React from "react";

export default function WalletConnection() {
  return (
    <>
      <div className="fq-faq-area fq-faq-bdr  pb-100">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <h1 className="text-color-yellow bold-text">
                Wallet Connection & Payments
              </h1>
              <div className="fq-faq-wrapper">
                <div className="tp-service-2-accordion-box">
                  <div className="accordion" id="accordionExample">
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefive"
                          aria-expanded="true"
                          aria-controls="collapsefive"
                        >
                          How do I buy a Kryptogram NFT?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapsefive"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Visit the Official Kryptogram NFT Marketplace on the
                            Tribe O Crypto website.
                          </p>
                          <div className="tp-about-2-content">
                            <span>Connect Your Crypto Wallet</span>
                            <p className="mb-30">
                              Supported wallets include MetaMask, Trust Wallet,
                              Coinbase Wallet, and more.
                            </p>
                            <span>Select Your NFTs</span>
                            <p className="mb-30">
                              Choose from Standard Kryptogram NFTs (for festival
                              entry and land ownership) or Exclusive Super Elite
                              NFTs (for VIP festival benefits).
                            </p>
                            <span>Complete Your Transaction</span>
                            <p className="mb-30">
                              Payments can be made using Tether (USDT/BEP20).
                            </p>
                            <span>Receive Your NFT</span>
                            <p className="mb-30">
                              Once the transaction is complete, your NFT will be
                              sent directly to your wallet.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSix"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                        >
                          What crypto currencies can I use to buy Kryptogram
                          NFTs?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapseSix"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>You can purchase Kryptogram NFTs using:</p>
                          <div class="service-details__fea-list">
                            <ul>
                              <li>Tether (USDT/BEP20)</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse7"
                          aria-expanded="false"
                          aria-controls="collapse7"
                        >
                          How can I participate if I don’t have a crypto wallet?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse7"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Setting up a crypto wallet is quick and easy. We
                            recommend using MetaMask or Trust Wallet for a
                            seamless experience.
                          </p>
                          <p>
                            Simply follow our step-by-step guide to create your
                            wallet and fund it with the required crypto currency
                            in just a few minutes.
                          </p>
                          <h3>Setting up a wallet is quick and easy:</h3>
                          <div className="tp-about-2-content pt-10">
                            <ul>
                              <li>
                                <span>Choose a Wallet</span>
                                <p className="mb-30">
                                  We recommend MetaMask (browser & mobile) or
                                  Trust Wallet (mobile).
                                </p>
                              </li>
                              <li>
                                <span>Download & Install</span>
                                <p className="mb-30">
                                  Get MetaMask from metamask.io or Trust Wallet
                                  from the App Store/Google Play.
                                </p>
                              </li>
                              <li>
                                <span>Create a Wallet </span>
                                <p className="mb-30">
                                  Follow the setup steps and secure your
                                  recovery phrase.
                                </p>
                              </li>
                              <li>
                                <span>Fund Your Wallet</span>
                                <p className="mb-30">
                                  Buy crypto via debit/credit card or transfer
                                  from an exchange.
                                </p>
                              </li>
                              <li>
                                <span>Connect & Start </span>
                                <p className="mb-30">
                                  Link your wallet to our platform and enjoy
                                  your Kryptogram NFT experience!
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse8"
                          aria-expanded="false"
                          aria-controls="collapse8"
                        >
                          Is my Kryptogram NFT stored securely?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse8"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Yes. Kryptogram NFTs are stored securely on the BSC
                            blockchain, ensuring full ownership, transparency,
                            and protection from fraud.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
